import 'ui-core/widgets/publication-content/js/publication-content';
import 'ui-core/widgets/article-tools/js/article-tools';
import 'ui-core/widgets/publication-content/js/crossref';

const loader = UX.loader;
loader.additionalController = function () {
    if ($('.altmetric-embed').length) {
        // LIT-263055
        $('.altmetric-embed').on('altmetric:hide', function () {
            $('.no-content').show();
        });
    }

    const $sections = $('#sectionMenu'),
        $window = $(window);
    if ($sections.length) {
        $window.on('scroll', function () {
            loader.setSectionHeight($sections, $window);
        });
    }
};

loader.setSectionHeight = function ($sections, $window) {
    //LIT-318905
    const $footer = $('.footer');
    const footerTop = $footer.offset().top;
    const marginTop = parseInt($footer.css('margin-top'));
    const scrollTop = $window.scrollTop() + $window.height();
    const headerHeight = $('.header').height();

    if (scrollTop >= footerTop) {
        $sections.css('max-height', `calc(100vh - ${headerHeight + scrollTop - footerTop + marginTop}px)`);
    } else {
        $sections.css('max-height', '');
    }
};

loader.truncation.linesToShow = 2;
loader.truncation.MobileLinesToShow = 2;
loader.truncation.showMoreText = $('article').data('more-authors-text');
loader.truncation.showLessText = $('article').data('less-authors-text');
loader.truncation.seeMoreIconMobile = 'icon-section_arrow_d';
